<div>
  <img loading="lazy" [src]="categoryImageUrl" itemprop="image" [attr.alt]="category().name" />
</div>
